// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KFWdKLjFvdpxAm {
  display: block;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.KFWdKLjFvdpxAm a {
  color: var(--ds-text-subtle, #44546f);
  cursor: pointer;
}
.WosF5epu9Sp0bP {
  display: inline-block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timestamp": `KFWdKLjFvdpxAm`,
	"timestamp-inline": `WosF5epu9Sp0bP`
};
export default ___CSS_LOADER_EXPORT___;
